import React, {createContext, useState, useMemo} from 'react';
import {View, StyleSheet} from 'react-native';
import {ModalContainer} from '@redlink/components/atoms/modalContainer';
import {Alert} from '@redlink/components/molecules/alert';
import {isMobile} from 'react-device-detect';

export const MessageContext = createContext({});

export const MessageProvider = ({children}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [alertData, setAlertData] = useState({});

    const MessageContextValue = useMemo(
        () => ({
            show: (message, data) => {
                setAlertData({message, data});
                setIsVisible(true);

                setTimeout(() => setIsVisible(false), 2000)
            },
        }),
        []
    );

    const {message, data} = alertData;

    return (
        <MessageContext.Provider value={MessageContextValue}>
            <View style={styles.mainContainer}>
                {children}
                {isVisible && <ModalContainer
                    visible={isVisible}
                    animationType="fade"
                    transparent
                    onRequestClose={() => setIsVisible(false)}
                    style={styles.modalContainer}
                >
                    <View style={styles.container}>
                        <Alert {...{message}} options={data}/>
                    </View>
                </ModalContainer>}
            </View>
        </MessageContext.Provider>
    );
};

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
    },
    container: {
        flex: 1,
        padding: 20,
        alignItems: isMobile ? 'center' : 'flex-end',
        justifyContent: isMobile ? 'flex-start' : 'flex-end',
    },
    modalContainer: {
        backgroundColor: 'rgba(0,0,0,0.1)'
    }
});
